import React from "react";

const GoalChip = ({ label }) => {
    return <div className="goal-chip-box">{label}</div>;
};

export default GoalChip;
